import {FC, useState, useEffect} from 'react'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'

type Props = {
  assessmentType: string
}

const api = new Api()

const InfoBoxContent: FC<Props> = ({assessmentType}) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<any>([])

  useEffect(() => {
    if (assessmentType == '') {
      return
    }

    fetchData()
  }, [assessmentType])

  const fetchData = () => {
    setLoading(true)
    api
      .getInfoBox({tipe: assessmentType})
      .then((response: any) => {
        const {data} = response
        setData(data?.meta?.message)
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error?.response
        toast.error(data?.message ?? data?.meta?.message)
      })
  }

  return (
    <div className='table-responsive px-8 py-5'>
      <table className='table table-bordered'>
        <thead className='text-center align-middle'>
          <tr className='border border-top-0 border-left-0 border-right-0 border-secondary'>
            <th rowSpan={2}>Scores</th>
            <th rowSpan={2}>Score Labels</th>
            {data?.aspek?.map((item: any) => (
              <th key={item.id}>
                {item.nama} ({item.bobot_persen})
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.score_labels &&
            [1, 2, 3, 4].map((score: any) => (
              <tr
                key={score}
                className='border border-top-0 border-left-0 border-right-0 border-secondary'
              >
                <td className='text-center align-middle'>{score === 3 ? 4 : score === 4 ? 5 : score}</td>
                <td className='align-middle'>{data?.score_labels[score]}</td>
                {data?.aspek?.map((item: any) => (
                  <td key={item.id}>
                    {item.tooltips[score]
                      ?.split(/\d+\.\s/)
                      .filter((text: any) => text.trim() !== '')
                      .map((text: any, idx: any) => (
                        <div key={idx}>
                          {item.tooltips[score].match(/\d+\.\s/g) ? <span>{idx + 1}. </span> : null}
                          {text.trim()}
                        </div>
                      ))}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

const InfoBoxTable: FC<Props> = ({assessmentType}) => {
  return <InfoBoxContent assessmentType={assessmentType} />
}

export default InfoBoxTable
